module.exports = __webpack_public_path__ + "img/social_icons.3989f538.png";